import users from "api/users";

import { populateProfile } from "store/actions/users";
import { setUserCookie } from "lib/userCookie";

const REDIRECT_KEY = "CLASS:redirect";

/** After login or sign-up: keep the profile and say where to go next. */
export function finishSignIn(profile, dispatch) {
  dispatch(populateProfile(profile));
  // Lets the public site (class.youwdin.com) show the account menu.
  setUserCookie({ name: profile.name, thumbnail: profile.avatar });
  return takeRedirect();
}

// Shared by LoginForm: the API sets the session cookie and returns the profile.
export default async function completeLogin({ email, password }, dispatch) {
  const res = await users.login({ email, password });
  return finishSignIn(res.data, dispatch);
}

// Where the student was heading before logging in (e.g. /joined/7).
export function rememberRedirect(path) {
  try {
    if (path && path.startsWith("/") && !path.startsWith("//")) localStorage.setItem(REDIRECT_KEY, path);
  } catch (e) {}
}

export function takeRedirect() {
  try {
    const path = localStorage.getItem(REDIRECT_KEY);
    localStorage.removeItem(REDIRECT_KEY);
    return path || "/";
  } catch (e) {
    return "/";
  }
}

// "/joined/7" -> "7" when the student arrived from a course's Enroll button.
export function pendingClassId() {
  let redirect = "";
  try {
    redirect = localStorage.getItem(REDIRECT_KEY) || "";
  } catch (e) {}
  const match = redirect.match(/^\/joined\/(\d+)/);
  return match ? match[1] : null;
}
